module.exports = __webpack_public_path__ + "media/newsletter_page/subscribed-27805d86.png";